import React, { useState, useEffect, useRef } from 'react';
import Tag from '../../components/ui/Tag';

const BenefitsGrid = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [titleVisible, setTitleVisible] = useState(false);
  const [paraVisible, setParaVisible] = useState(false);
  const [imgVisible, setImgVisible] = useState(false);
  const sectionRef = useRef(null);

  // Intersection Observer setup
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true); // Section is in view
          }
        });
      },
      {
        threshold: 0.3, // 50% of the section must be in view
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current); // Observe the section
    }

    // Cleanup observer on unmount
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  // Trigger individual animations after section is visible
  useEffect(() => {
    if (isVisible) {
      setTitleVisible(true);
      setTimeout(() => setParaVisible(true), 300); // Delay para animation
      setTimeout(() => setImgVisible(true), 600); // Delay image animation
    }
  }, [isVisible]);

  return (
    <section
      ref={sectionRef}
      className={`bg-white section-spacing transition-all duration-1000 ease-in-out ${
        isVisible ? 'opacity-100' : 'opacity-0'
      }`}
    >
      <div className="container mx-auto px-4 md:px-8">
        <div className="mb-0">
          <h2
            className={`text-2xl md:text-4xl lg:text-4xl font-extralight text-[#000000] mb-6 text-center mt-10 md:text-center transition-all duration-1000 ${
              titleVisible
                ? 'opacity-100 translate-y-0 animate-slideUp'
                : 'opacity-0 translate-y-10'
            }`}
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Elixir: More Than Honey, An Experience
          </h2>
          <p
            className={`md:text-xl text-[#666] max-w-4xl mx-auto px-8 text-center md:text-center transition-all duration-1000 ${
              paraVisible ? 'opacity-100 translate-y-0 animate-slideUp' : 'opacity-0 translate-y-10'
            }`}
          >
            Elixir is a rare and exceptional honey, born from the sun-drenched lands of Tunisia.
            It's a journey for the senses, a celebration of Mediterranean heritage, and a gift of
            pure well-being.
          </p>
        </div>
      </div>
    </section>
  );
};

export default BenefitsGrid;
